import React from 'react';
import Icon from '../../../common/icons/Icon';
import classnames from 'classnames';
import './TierList.scss';

const TierList = ({ tierFeatures, removeAsterisk = false, hasBorder = true }) => (
	<ul className={classnames('tier-list', { ['tier-list--hasBorder']: hasBorder })}>
		{tierFeatures?.features.map((feature, index) => (
			<li key={`feature-${index}}`}>
				<span>
					{feature.description}
					{feature.description.includes('tegelijk, op 1 adres') && !removeAsterisk ? '*' : ''}
				</span>
				<span className="tier-list__feature">
					{typeof feature.feature === 'string' ? (
						feature.feature
					) : feature.feature ? (
						<Icon
							className="tier-list__check"
							name="checkmarkB"
							height={16}
							width={16}
							viewBox="0 0 20 16"
						/>
					) : (
						<Icon
							className="tier-list__cross"
							name="cross"
							viewBox="0 0 16 16"
							width={16}
							height={16}
						/>
					)}
				</span>
			</li>
		))}
	</ul>
);

export default TierList;
